import { render, staticRenderFns } from "./BundleOfferModal.vue?vue&type=template&id=8e3a180e&scoped=true"
import script from "./BundleOfferModal.vue?vue&type=script&lang=js"
export * from "./BundleOfferModal.vue?vue&type=script&lang=js"
import style0 from "./BundleOfferModal.vue?vue&type=style&index=0&id=8e3a180e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3a180e",
  null
  
)

export default component.exports